module.exports = __webpack_public_path__ + "static/media/goat.0f4cfa79.gif";